import store from '@root/store';

export default {
    setup() {

        return {

        }
    },
    data() {
        return {
            PRODUCT_TYPES: {
                EQUIPMENT: 1,
                MEDICINES: 2,
            },
            PRODUCT_STATUSES: {
                NEW: 1,
                USED: 2,
                MAINTENANCE: 3,
                RENT: 4,
                RETURN_FROM_RENT: 5,
                REPAIRED: 6,
            }
        }
    },
    methods: {

        mixinShowAlert1(message, icon, type, redirect_to = null, params = {}) {
            this.$swal({
                title: 'معلومات',
                text: message,
                icon: icon,
                type: type,
                confirmButtonText: 'موافق',
                // confirmButtonColor: '#16918b',
            }).then(() => {
                if (redirect_to)
                    this.$router.push({ name: redirect_to, params: params });
            });
        },

        mixinConfirmAlert(dispatch_delete, dispatch_fetch, id, filter) {
            let answer = this.$swal({
                    icon: 'warning',
                    title: "Are you sure ?",
                    text: "You will delete this record",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it !",
                    cancelButtonText: "No, cancel !",
                    closeOnConfirm: false,
                    closeOnCancel: false
                })
                .then((result) => {
                    if (result.value) {
                        store.commit('admin/PleaseStartLoading');
                        store.dispatch(dispatch_delete, id).then((Response) => {
                            store.commit('admin/PleaseStopLoading');
                            this.$swal({
                                title: 'Information',
                                text: 'Deleted Success',
                                icon: 'success',
                                type: 'success',
                                confirmButtonText: 'ok',
                            }).then(() => {
                                if (dispatch_fetch) {
                                    store.commit('admin/PleaseStartLoading');
                                    store.dispatch(dispatch_fetch, filter).then(() => {
                                        store.commit('admin/PleaseStopLoading');
                                    }).catch(() => {
                                        store.commit('admin/PleaseStopLoading');
                                    });
                                } else {
                                    store.commit('admin/PleaseStopLoading');
                                }
                            });
                        }).catch(() => {
                            store.commit('admin/PleaseStopLoading');
                        })
                    }
                });
        },

    }
};